<template>
    <div class="hsjapp">
        <img class="hsj_logo" src="./img/hsj_logo.png" alt="">
        <div class="content">
            <div class="content_title">护士加app</div>
            <div class="content_tip">帮助中国护士长本事涨收入长地位</div>
        </div>
        <Button class="btn-open" size="mini" @click="openHsj">立即打开</Button>
    </div>
</template>
<script>
    import { Button } from 'vant'
    import callApp from '@/config/callApp.js'
    import { hsjH5BurialPoint } from '@/utils/shareCommon.js'
    export default {
        name: 'openHsjApp',
        props: {
            mark:{
                type:String,
                default:"",
            }
        },
        methods: {
            openHsj() {
                if(this.mark == "shareCourse"){
                    hsjH5BurialPoint('B000026', 'B000026-005', {id: PAGE_PARAMS.courseId});
                }

                setTimeout(()=>{
                    window.location.href = callApp.yingyongbao;
                },500)
            }
        },
        components: { Button }
    }
</script>
<style lang="scss" scoped>
    .hsjapp {
        display: flex;
        height:50px;
        padding: 0 16px;
        background:rgba(243,245,249,1);
        align-items: center;
        justify-content: space-between;
        .hsj_logo {
            width: 30px;
            margin-right: 7px;
        }
        .content {
            flex: 1;
            &_title {
                font-size:14px;
                font-weight:400;
                color:rgba(34,34,34,1);
            }
            &_tip {
                margin-top: 3px;
                font-size:10px;
                font-weight:300;
                color:rgba(102,102,102,1);
            }
        }
        .btn-open {
            width:60px;
            background:rgba(255,68,68,1);
            border-radius:3px;
            font-size:10px;
            font-weight:400;
            color:rgba(255,255,255,1);
        }
    }
</style>
